import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

export function useLightbox(containerId: string) {
  const lightbox = ref<Nullable<PhotoSwipeLightbox>>(null)
  const lightboxInit = () => {
    if (lightbox.value) return

    lightbox.value = new PhotoSwipeLightbox({
      gallery: `#${containerId}`,
      children: 'img',
      pswpModule: () => import('photoswipe'),
      showHideAnimationType: 'zoom',
      wheelToZoom: true,
    })
    lightbox.value.init()
    lightbox.value.addFilter('domItemData', (_itemData, element) => {
      const _element = element as HTMLImageElement

      return {
        src: _element.src,
        w: _element.naturalWidth,
        h: _element.naturalHeight,
      }
    })
  }

  onScopeDispose(() => {
    lightbox.value?.destroy()
  })

  return {
    lightbox,
    lightboxInit,
  }
}
